import React, { Component } from "react"
import Modal from "react-modal"
import CustomerCreateModalUI from './CustomerCreateModalUI'
import RestApiUtils from "../../../apiclient/moebli/RestApiUtils"

class CustomerCreateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      //
      submitted: false,
      //
      contactFirstName: '',
      contactFirstNameError: null,
      contactLastName: '',
      contactLastNameError: null,
      contactPhone: '',
      contactPhoneError: null,
      contactEmail: '',
      contactEmailError: null,
      panNumber: '',
      panNumberError: null,
      state: '',
      stateError: null,
      city: '',
      cityError: null,
      postalCode: '',
      postalCodeError: null,
      streetAddress: '',
      streetAddressError: null,
      CollectionDueInDays: '',
      CollectionDueInDaysError: null,
    }
  }

  render() {
    return (
      <CustomerCreateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        //
        createMode={this.props.createMode}
        submitted={this.state.submitted}
        //
        onSubmit={this.onSubmit}
        onCancelCreate={this.onCancelCreate}
        //
        contactFirstName={this.state.contactFirstName}
        onContactFirstNameChange={(event) => { this.setState({ contactFirstName: event.target.value }) }}
        contactFirstNameError={this.state.contactFirstNameError}
        setContactFirstNameError={(error) => { this.setState({ contactFirstNameError: error }) }}
        //
        contactLastName={this.state.contactLastName}
        onContactLastNameChange={(event) => { this.setState({ contactLastName: event.target.value }) }}
        contactLastNameError={this.state.contactLastNameError}
        setContactLastNameError={(error) => { this.setState({ contactLastNameError: error }) }}
        //
        contactPhone={this.state.contactPhone}
        onContactPhoneChange={(event) => { this.setState({ contactPhone: event.target.value }) }}
        contactPhoneError={this.state.contactPhoneError}
        setContactPhoneError={(error) => { this.setState({ contactPhoneError: error }) }}
        //
        contactEmail={this.state.contactEmail}
        onContactEmailChange={(event) => { this.setState({ contactEmail: event.target.value }) }}
        contactEmailError={this.state.contactEmailError}
        setContactEmailError={(error) => { this.setState({ contactEmailError: error }) }}
        //
        panNumber={this.state.panNumber}
        onPanNumberChange={(event) => { this.setState({ panNumber: event.target.value }) }}
        panNumberError={this.state.panNumberError}
        setPanNumberError={(error) => { this.setState({ panNumberError: error }) }}
        //
        state={this.state.state}
        onStateChange={(event) => { this.setState({ state: event.target.value }) }}
        stateError={this.state.stateError}
        setStateError={(error) => { this.setState({ stateError: error }) }}
        stateList={this.props.stateList}
        //
        city={this.state.city}
        onCityChange={(event) => { this.setState({ city: event.target.value }) }}
        cityError={this.state.cityError}
        setCityError={(error) => { this.setState({ cityError: error }) }}
        //
        postalCode={this.state.postalCode}
        onPostalCodeChange={(event) => { this.setState({ postalCode: event.target.value }) }}
        postalCodeError={this.state.postalCodeError}
        setPostalCodeError={(error) => { this.setState({ postalCodeError: error }) }}
        //
        streetAddress={this.state.streetAddress}
        onStreetAddressChange={(event) => { this.setState({ streetAddress: event.target.value }) }}
        streetAddressError={this.state.streetAddressError}
        setStreetAddressError={(error) => { this.setState({ streetAddressError: error }) }}
        //
        collectionDueInDays={this.state.CollectionDueInDays}
        onCollectionDueInDaysChange={(event) => { this.setState({ CollectionDueInDays: event.target.value }) }}
        CollectionDueInDaysError={this.state.CollectionDueInDaysError}
        setCollectionDueInDaysError={(error) => { this.setState({ CollectionDueInDaysError: error }) }}
      />
    )
  }

  onCancelCreate = () => {
    this.setState({
      submitted: false,
      errorList: null
    })
    this.props.onCancelCreate()
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/customers`,
      this.onSubmitCallback, {
      contactFirstName: this.state.contactFirstName,
      contactLastName: this.state.contactLastName,
      contactPhone: this.state.contactPhone,
      contactEmail: this.state.contactEmail,
      panNumber: this.state.panNumber,
      state: this.state.state,
      city: this.state.city,
      postalCode: this.state.postalCode,
      streetAddress: this.state.streetAddress,
      CollectionDueInDays: this.state.CollectionDueInDays,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelCreate()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default CustomerCreateModalSF;